import jApi from './jApi';

export default {
  getLeaveEmployee(req) {
    const api = jApi.generateApi();
    return api.post('times/leaves-service/leaves/all-employee', req)
      .then(res => res.data);
  },

  getLeaveEmployeeByRestriction(params) {
    const api = jApi.generateApi();
    return api.get('times/leaves-service/monitorsV3', { params })
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiLeaveMonitor.js